import { useEffect, useState } from 'react';
import Tab from '../../components/Tab/Tab';
import VehicleDetails from './View/VehicleDetails';
import CompanyDetails from './View/CompanyDetails';
import SellerDetails from './View/SellerDetails';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../../axios/axios';
import FlooringDetails from './View/FlooringDetails';
import { ReactComponent as BackIcon } from '../../images/back.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setFloorCaseDetailsFilter } from '../../redux/slice/newFloorApplication';
import PaymentSummary from './View/PaymentSummary';
import PaymentHistory from './View/PaymentHistory';
import { PaymentSummaryData } from './UserData';
import { Button } from 'antd';
import DisbursementDetails from './View/DisbursementDetails';

const DefaultFilter = {
  activeTab: 0,
  statusTab: 0,
};

const ViewFlooringCases = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const flooringCaseDetailsFilter = useSelector(
    (state) => state?.newFloorApplication?.flooringCaseDetailsFilter
  );
  const AppId = location?.state?.appId;
  const Date = location?.state?.date;
  const isOngoing = location.state.isOngoing !== undefined ? location.state.isOngoing : false;
  const pagePermission = location.state.pagePermission;

  const tabs = [
    isOngoing && 
    // 'Payment History',
    'Flooring Details',
    'Vehicle Details',
    'Company Details',
    'Seller Details',
    isOngoing && 'Disbursement',
  ].filter(Boolean);

  const [applyFilters, setApplyFilters] = useState(
    flooringCaseDetailsFilter &&
      Object.keys(flooringCaseDetailsFilter).length > 0
      ? { ...DefaultFilter, ...flooringCaseDetailsFilter }
      : DefaultFilter
  );
  const [activeTab, setActiveTab] = useState(applyFilters?.activeTab);
  const [ApplicationData, setApplicationData] = useState([]);
  const SelectedAgent = ApplicationData?.cart
    ?.filter((it) => it?.agent?.agent_approved_status == 1)
    .pop();

  const [flooringSettingsData, setFlooringSettingsData] = useState({});
  const [isModelOpen, setisModelOpen] = useState({
    type: 'Confirm',
    open: false,
    crntStatus: 1,
    amount: '',
    id: '',
  });
  const [agentRemarks, setAgentRemarks] = useState('');

  const GetApplicationData = async () => {
    const resp = await axios.get(`flooring/application/show/${AppId}`);
    if (resp?.status < 400) {
      setApplicationData(resp.data?.data);
    }
  };

  const GetOwnerType = (item, val) => {
    const temp = flooringSettingsData[`${item}`]?.filter(
      (it) => it.value == val
    );
    if (temp?.length > 0) {
      return temp[0]?.label;
    } else {
      return '';
    }
  };

  const GetFlooringSettings = async () => {
    const resp = await axios.get('/flooring/settings');
    if (resp.status < 400) {
      setFlooringSettingsData(resp.data?.data);
    }
  };

  const HandleFilters = (key, value) => {
    setApplyFilters({
      ...applyFilters,
      ...key,
    });
    dispatch(
      setFloorCaseDetailsFilter({
        ...applyFilters,
        ...key,
      })
    );
  };
  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    HandleFilters({ activeTab: tabIndex });
    // You can perform any other actions you need when a tab is changed here
  };

  useEffect(() => {
    if (AppId !== null && AppId !== undefined) {
      GetApplicationData();
      GetFlooringSettings();
    }
  }, [AppId]);
  return (
    <section className='common_container'>
      <header className='common-header flex justify-between flex-wrap gap-4'>
        <div className='common-header-body'>
          <h1 className=' flex items-center gap-3'>
            <span
              className='cursor-pointer'
              onClick={() => {
                HandleFilters({ activeTab: 0 });
                navigate('/flooring-cases', {
                  state: {
                    ...pagePermission,
                  },
                });
              }}
            >
              <BackIcon />
            </span>
            Flooring Cases
            <Button
              type='submit'
              className='sav_btn'
              onClick={() => {
                navigate('/flooring-cases/view/summary', {
                  state: {
                    ...location.state,
                    AgentId: SelectedAgent?.agent?.id,
                    pagePermission: pagePermission
                  },
                });
              }}
            >
              Case Summary
            </Button>
          </h1>
        </div>
      </header>
      <section>
        <div className='tab-section'>
          <Tab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
          {!isOngoing && (
            <div className='cases-publish'>
              <h2>
                Publish on: <span>{Date?.submitted_date}</span>
              </h2>
              <h2>
                Case Expiry:: <span>{Date?.expiry_date}</span>
              </h2>
            </div>
          )}
        </div>
        {/* {activeTab === 0 && isOngoing && (
          <section>
            <PaymentSummary
              isModelOpen={isModelOpen}
              setisModelOpen={setisModelOpen}
              FloorCaseDetails={ApplicationData}
              agentRemarks={agentRemarks}
              setAgentRemarks={setAgentRemarks}
              OnClose={() => {
                setisModelOpen({
                  type: 'Confirm',
                  open: false,
                  crntStatus: 1,
                  amount: '',
                  id: '',
                });
                setAgentRemarks('');
              }}
              GetFloorCaseDetails={GetApplicationData}
              pagePermission={pagePermission}
            />
          </section>
        )} */}
        <div className='tab-body-section'>
          {Object.keys(ApplicationData)?.length > 0 &&
            Object.keys(ApplicationData) !== undefined && (
              <div
                className={`view-flooring-cases flooring-cases-${activeTab === 6
                  ? 'detail'
                  : activeTab === 3
                    ? 'others'
                    : 'others pt-5'
                  }`}
              >
                {activeTab == (isOngoing ? 0 : 0) && (
                  <FlooringDetails
                    ApplicationData={ApplicationData}
                    HandleFilters={HandleFilters}
                    statusTab={applyFilters?.statusTab}
                    returnState={location?.state}
                  />
                )}
                {activeTab === (isOngoing ? 1 : 1) && (
                  <VehicleDetails
                    ApplicationData={ApplicationData}
                    GetOwnerType={GetOwnerType}
                  />
                )}
                {activeTab === (isOngoing ? 2 : 2) && (
                  <CompanyDetails
                    ApplicationData={ApplicationData}
                    GetOwnerType={GetOwnerType}
                  />
                )}
                {activeTab === (isOngoing ? 3 : 3) && (
                  <SellerDetails
                    ApplicationData={ApplicationData}
                    GetOwnerType={GetOwnerType}
                  />
                )}
                {activeTab === 4 && isOngoing && (
                  <DisbursementDetails
                    ApplicationData={ApplicationData}
                    GetOwnerType={GetOwnerType}
                  />
                )}
              </div>
            )}

          {/* {activeTab === 0 && isOngoing && (
            <PaymentHistory
              isModelOpen={isModelOpen}
              setisModelOpen={setisModelOpen}
              FloorCaseDetails={ApplicationData}
              agentRemarks={agentRemarks}
              setAgentRemarks={setAgentRemarks}
              OnClose={() => {
                setisModelOpen({
                  type: 'Confirm',
                  open: false,
                  crntStatus: 1,
                  amount: '',
                  id: '',
                });
                setAgentRemarks('');
              }}
              GetFloorCaseDetails={GetApplicationData}
              pagePermission={pagePermission}
            />
          )} */}
        </div>
      </section>
    </section>
  );
};
export default ViewFlooringCases;
